import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, CopyButton } from '@node-space/ui-components'
import { useWalletContext } from 'hooks/context'
import { useProtocolContext } from 'hooks/context/useProtocolContext'
import { getWalletProtocolNetwork } from './getWalletProtocolNetwork'

export const WalletAddressDetails = () => {
  const { t } = useTranslation()
  const wallet = useWalletContext()
  const { currentProtocol } = useProtocolContext()

  const address = currentProtocol?.address || wallet?.address
  const { selectedProtocolNetwork: protocolNetwork } = getWalletProtocolNetwork(
    wallet,
    currentProtocol
  )

  return (
    <Box className="self-center">
      <p className="text-label text-foreground-prominent">
        {t('yourAddress', {
          currencyCode: wallet.currency?.code?.toUpperCase(),
          protocol: protocolNetwork ? `(${protocolNetwork} network)` : '',
        })}
      </p>
      <Box testId="wallet-details-address" flex paddingB={32}>
        <p className="w-48 break-all md:w-full text-body-regular text-foreground-faint">
          {address}
        </p>
        <CopyButton copyText={address} />
      </Box>
      {wallet.lookup && (
        <>
          <p
            data-testid="wallet-details-destination-tag"
            className="text-label text-foreground-prominent"
          >
            {t('destinationTag')}
          </p>

          <Box testId="wallet-details-wallet-lookup" flex justify="between">
            <p
              data-testid="wallet-details-wallet-lookup"
              className="break-all text-body-regular text-foreground-faint text-center"
            >
              {wallet.lookup}
            </p>

            <CopyButton copyText={wallet.lookup} />
          </Box>
        </>
      )}
    </Box>
  )
}
